<button mat-flat-button (click)="addExternalInfo(DialogComponent)" color="primary" [matBadge]="numberKeyValues$|async">
    {{ title }}
</button>

<ng-template #DialogComponent>
    <mat-dialog-content class="flex-direction-column flex-center-center width-container">
        <mat-accordion [formGroup]="form">
            @for (externalInfoGroup of (externalInfoGrouped$|async); track externalInfoGroup.type) {
                <mat-expansion-panel
                        [hideToggle]="(externalInfoGroup.values==null||externalInfoGroup.values.length==0)">
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            @if (externalInfoGroup.type == externalInfoType.RECORD_SETPOINT) {
                                <mat-checkbox
                                        (click)="$event.stopPropagation()"
                                        (change)="addRecordSetpoint($event.checked)"
                                        formControlName="recordSetpoint">
                                </mat-checkbox>
                            } @else if (externalInfoGroup.type == externalInfoType.RECORD_WEATHER_TEMPERATURE) {
                                <mat-checkbox
                                        (click)="$event.stopPropagation()"
                                        (change)="addRecordWeatherTemperature($event.checked)"
                                        formControlName="recordWeatherTemperature">
                                </mat-checkbox>
                            } @else {
                                <button (click)="$event.stopPropagation();unsetIsEdit();addNew(externalInfoGroup.type,FormType)"
                                        mat-raised-button
                                        color="primary">
                                    <mat-icon>add</mat-icon>
                                </button>
                            }
                        </mat-panel-title>
                        <mat-panel-description> {{ ('IotDevices.externalInfoType.' + externalInfoGroup.type)|translate }}</mat-panel-description>
                    </mat-expansion-panel-header>
                    @switch (externalInfoGroup.type) {
                        @case (externalInfoType.RECORD_SETPOINT) {

                        }
                        @case (externalInfoType.RECORD_WEATHER_TEMPERATURE) {
                        }
                        @case (externalInfoType.FROM) {
                            <mat-chip-set>
                                @for (externalInfo of externalInfoGroup.values; track externalInfo) {
                                    <mat-chip
                                            (click)="editExternalInfo(externalInfo,FormType)"
                                    >{{ externalInfo.sensorId|transformValueByPredicateFunction:getElementNamePredicate:elementsSignal() }}
                                        |
                                        {{ externalInfo.infoName |transformValueByPredicateFunction:getSensorDataNamePredicate:sensorsDataSignal() }}
                                    </mat-chip>
                                }
                            </mat-chip-set>
                        }
                        @case (externalInfoType.VARIATION) {
                            @for (externalInfo of externalInfoGroup.values; track externalInfo) {
                                <mat-chip (click)="editExternalInfo(externalInfo,FormType)">
                                    {{ externalInfo.variation?.sensorId|transformValueByPredicateFunction:getElementNamePredicate:elementsSignal() }}&nbsp;|&nbsp;{{ externalInfo.variation?.infoName |transformValueByPredicateFunction:getSensorDataNamePredicate:sensorsDataSignal() }}
                                </mat-chip>
                                @if (!$last) {
                                    <mat-divider></mat-divider>
                                }
                            }
                        }
                        @case (externalInfoType.TIME_DERIVATE) {
                            @for (externalInfo of externalInfoGroup.values; track externalInfo) {
                                <mat-chip (click)="editExternalInfo(externalInfo,FormType)">
                                    {{ externalInfo.timeDerivate?.sensorId|transformValueByPredicateFunction:getElementNamePredicate:elementsSignal() }}&nbsp;|&nbsp;{{ externalInfo.timeDerivate?.infoName |transformValueByPredicateFunction:getSensorDataNamePredicate:sensorsDataSignal() }}
                                </mat-chip>
                                @if (!$last) {
                                    <mat-divider></mat-divider>
                                }
                            }
                        }
                        @case (externalInfoType.MOVING_MEAN) {
                            @for (externalInfo of externalInfoGroup.values; track externalInfo) {
                                <mat-chip (click)="editExternalInfo(externalInfo,FormType)">
                                    {{ externalInfo.movingMean?.sensorId|transformValueByPredicateFunction:getElementNamePredicate:elementsSignal() }}&nbsp;|&nbsp;{{ externalInfo.movingMean?.infoName |transformValueByPredicateFunction:getSensorDataNamePredicate:sensorsDataSignal() }}&nbsp;|&nbsp;{{ externalInfo.movingMean?.minutes }}
                                </mat-chip>
                                @if (!$last) {
                                    <mat-divider></mat-divider>
                                }
                            }
                        }
                        @case (externalInfoType.DIFF) {
                            @for (externalInfo of externalInfoGroup.values; track externalInfo) {
                                <div (click)="editExternalInfo(externalInfo,FormType)">
                                    <ng-container
                                            [ngTemplateOutlet]="SumDiffValue"
                                            [ngTemplateOutletContext]="externalInfo|transformValueByPredicateFunction:getDifSumAndSinglePredicate:elementsSignal():sensorsDataSignal()">
                                    </ng-container>
                                </div>
                                @if (!$last) {
                                    <mat-divider></mat-divider>
                                }
                            }
                        }
                        @case (externalInfoType.MAX) {
                            @for (externalInfo of externalInfoGroup.values; track externalInfo) {
                                <div (click)="editExternalInfo(externalInfo,FormType)">
                                    <ng-container
                                            [ngTemplateOutlet]="MultipleAndSingle"
                                            [ngTemplateOutletContext]="externalInfo.max|transformValueByPredicateFunction:getMultipleAndSinglePredicate:elementsSignal():sensorsDataSignal()">
                                    </ng-container>
                                </div>
                                @if (!$last) {
                                    <mat-divider></mat-divider>
                                }
                            }
                        }
                        @case (externalInfoType.MEAN) {
                            @for (externalInfo of externalInfoGroup.values; track externalInfo) {
                                <div (click)="editExternalInfo(externalInfo,FormType)">
                                    <ng-container
                                            [ngTemplateOutlet]="MultipleAndSingle"
                                            [ngTemplateOutletContext]="externalInfo.mean|transformValueByPredicateFunction:getMultipleAndSinglePredicate:elementsSignal():sensorsDataSignal()">
                                    </ng-container>
                                </div>
                                @if (!$last) {
                                    <mat-divider></mat-divider>
                                }
                            }
                        }
                        @case (externalInfoType.MIN) {
                            @for (externalInfo of externalInfoGroup.values; track externalInfo) {
                                <div (click)="editExternalInfo(externalInfo,FormType)">
                                    <ng-container

                                            [ngTemplateOutlet]="MultipleAndSingle"
                                            [ngTemplateOutletContext]="externalInfo.min|transformValueByPredicateFunction:getMultipleAndSinglePredicate:elementsSignal():sensorsDataSignal()">
                                    </ng-container>
                                </div>
                                @if (!$last) {
                                    <mat-divider></mat-divider>
                                }
                            }
                        }
                        @case (externalInfoType.SUM) {
                            @for (externalInfo of externalInfoGroup.values; track externalInfo) {
                                <div (click)="editExternalInfo(externalInfo,FormType)">
                                    <ng-container
                                            [ngTemplateOutlet]="MultipleAndSingle"
                                            [ngTemplateOutletContext]="externalInfo.sum|transformValueByPredicateFunction:getMultipleAndSinglePredicate:elementsSignal():sensorsDataSignal()">
                                    </ng-container>
                                </div>
                                @if (!$last) {
                                    <mat-divider></mat-divider>
                                }
                            }
                        }

                    }


                </mat-expansion-panel>
            }
        </mat-accordion>
    </mat-dialog-content>
    <mat-dialog-actions>
        <button mat-flat-button color="primary" [mat-dialog-close]="undefined">
            <mat-icon>check</mat-icon>
        </button>
    </mat-dialog-actions>
</ng-template>

<ng-template #MultipleAndSingle let-names="names" let-infoName="infoName">
    <div class="w100" style="text-align: center">
        {{ infoName |transformValueByPredicateFunction:getSensorDataNamePredicate:sensorsDataSignal() }}
    </div>
    <mat-chip-set aria-label="Fish selection">
        @for (name of names; track name) {
            <mat-chip>{{ name }}
            </mat-chip>
        }
    </mat-chip-set>
</ng-template>
<ng-template #SumDiffValue let-namesSum="elementsNameSum" let-namesDiff="elementsNameDiff" let-infoName="infoName">
    <div class="w100" style="text-align: center">
        {{ infoName |transformValueByPredicateFunction:getSensorDataNamePredicate:sensorsDataSignal() }}
    </div>
    <mat-chip-set>
        @for (name of namesSum; track name) {
            <mat-chip>{{ name }}
            </mat-chip>
        }
    </mat-chip-set>
    <mat-chip-set>
        @for (name of namesDiff; track name) {
            <mat-chip>{{ name }}
            </mat-chip>
        }
    </mat-chip-set>
</ng-template>


<ng-template #FormType>
    <mat-dialog-content class="flex-direction-column flex-center-center width-container">
        <form [formGroup]="form">
            <div formGroupName="editValue">
                @switch (editType$|async) {
                    @case (externalInfoType.FROM) {
                        <app-auto-complete-form
                                [title]="'SensorEvent.sensorId'|translate"
                                registerOnChangeKeyValue="valueForm"
                                formControlName="sensorId"
                                [items]="elementsPossibleValues()"
                        >

                        </app-auto-complete-form>
                        <app-auto-complete-form
                                [title]="'SensorEvent.infoName'|translate"
                                registerOnChangeKeyValue="valueForm"
                                formControlName="infoName"
                                [items]="sensorsDataPossibleValues()"
                        >

                        </app-auto-complete-form>
                    }
                    @case (externalInfoType.MAX) {
                        <ng-container
                                [ngTemplateOutlet]="MAXMINMEAN"
                        >
                        </ng-container>
                    }
                    @case (externalInfoType.MEAN) {
                        <ng-container
                                [ngTemplateOutlet]="MAXMINMEAN"
                        >
                        </ng-container>
                    }
                    @case (externalInfoType.MIN) {
                        <ng-container
                                [ngTemplateOutlet]="MAXMINMEAN"
                        >
                        </ng-container>
                    }
                    @case (externalInfoType.SUM) {
                        <ng-container
                                [ngTemplateOutlet]="MAXMINMEAN"
                        >
                        </ng-container>
                    }
                    @case (externalInfoType.MOVING_MEAN) {
                        <app-auto-complete-form
                                registerOnChangeKeyValue="valueForm"
                                [title]="'SensorEvent.sensorId'|translate"
                                formControlName="sensorId"
                                [items]="elementsPossibleValues()"
                        >

                        </app-auto-complete-form>
                        <app-auto-complete-form
                                [title]="'SensorEvent.infoName'|translate"
                                formControlName="infoName"
                                registerOnChangeKeyValue="valueForm"
                                [items]="sensorsDataPossibleValues()"
                        >

                        </app-auto-complete-form>
                        <app-increment-field formControlName="minutes"

                                             [hintMessage]="'periodoMediaMobile'|translate"
                                             [min]="0"
                                             [step]="1"
                                             [showClearButton]="true"
                        >
                        </app-increment-field>
                    }
                    @case (externalInfoType.VARIATION) {
                        <app-auto-complete-form
                                registerOnChangeKeyValue="valueForm"
                                [title]="'SensorEvent.sensorId'|translate"
                                formControlName="sensorId"
                                [items]="elementsPossibleValues()"
                        >

                        </app-auto-complete-form>
                        <app-auto-complete-form
                                [title]="'SensorEvent.infoName'|translate"
                                formControlName="infoName"
                                registerOnChangeKeyValue="valueForm"
                                [items]="sensorsDataPossibleValues()"
                        >

                        </app-auto-complete-form>
                    }
                    @case (externalInfoType.TIME_DERIVATE) {
                        <app-auto-complete-form
                                registerOnChangeKeyValue="valueForm"
                                [title]="'SensorEvent.sensorId'|translate"
                                formControlName="sensorId"
                                [items]="elementsPossibleValues()"
                        >

                        </app-auto-complete-form>
                        <app-auto-complete-form
                                [title]="'SensorEvent.infoName'|translate"
                                formControlName="infoName"
                                registerOnChangeKeyValue="valueForm"
                                [items]="sensorsDataPossibleValues()"
                        >

                        </app-auto-complete-form>
                    }
                    @case (externalInfoType.DIFF) {
                        <app-multi-select-form-field appearance="outline"
                                                     formControlName="sensorIdsDiff"
                                                     labelSearch="{{'IotDevices.sensorIdsDiff'|translate}}"
                                                     [multiple]="true"
                                                     class="w100"
                                                     style="max-width: 300px!important;"
                                                     [possibleValues]="elementsPossibleValues_v2()"

                        >
                        </app-multi-select-form-field>
                        <app-multi-select-form-field appearance="outline"
                                                     formControlName="sensorIdsSum"
                                                     labelSearch="{{'IotDevices.sensorIdsSum'|translate}}"
                                                     [multiple]="true"
                                                     class="w100"
                                                     style="max-width: 300px!important;"
                                                     [possibleValues]="elementsPossibleValues_v2()"

                        >
                        </app-multi-select-form-field>
                        <app-auto-complete-form
                                [title]="'SensorEvent.infoName'|translate"
                                formControlName="infoName"
                                registerOnChangeKeyValue="valueForm"
                                [items]="sensorsDataPossibleValues()"
                        >

                        </app-auto-complete-form>
                    }
                }
            </div>

        </form>
    </mat-dialog-content>
    <mat-dialog-actions>
        @if (isEdit()) {
            <button mat-flat-button color="accent" (click)="editValue()" [mat-dialog-close]="undefined">
                <mat-icon>edit</mat-icon>
            </button>
            <button mat-flat-button color="warn" (click)="deleteValue()" [mat-dialog-close]="undefined">
                <mat-icon>delete</mat-icon>
            </button>
        } @else {
            <button mat-flat-button color="accent" (click)="addInValue()" [mat-dialog-close]="undefined">
                <mat-icon>add</mat-icon>
            </button>
        }
        @if (warningMessages$|async; as message) {
            <mat-hint class="text-color-accent">
                {{ message.message|translate }} "{{ message.infoName }}"
            </mat-hint>
        }
    </mat-dialog-actions>

</ng-template>


<ng-template #MAXMINMEAN>
    <form [formGroup]="form">
        <div formGroupName="editValue">
            <app-multi-select-form-field appearance="outline"
                                         formControlName="sensorIds"
                                         labelSearch="{{'SensorEvent.sensorId'|translate}}"
                                         [multiple]="true"
                                         class="w100"
                                         [title]="'IotDevices.sensorIds'|translate"
                                         style="max-width: 300px!important;"
                                         [possibleValues]="elementsPossibleValues_v2()"

            >
            </app-multi-select-form-field>
            <app-auto-complete-form
                    [title]="'SensorEvent.infoName'|translate"
                    registerOnChangeKeyValue="valueForm"
                    formControlName="infoName"
                    [items]="sensorsDataPossibleValues()"
            >

            </app-auto-complete-form>
        </div>
    </form>
</ng-template>